module.exports = __webpack_public_path__ + "img/logo.d9d5a8d2.jpg";